import { Routes } from "@angular/router";

import { FullComponent } from "./layouts/full/full.component";
import { AuthGuard } from "./core/shared/guard/auth.guard";
import { RoleGuard } from "./core/shared/guard";
import { RaportModule } from "./module/raport/raport.module";

export const AppRoutes: Routes = [
  {
    path: "",
    component: FullComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        redirectTo: "/door",
        pathMatch: "full",
      },
      {
        path: "dashboard",
        canActivate: [RoleGuard],
        data: { role: "rd_dashboard" },
        loadChildren: () =>
          import("./dashboard/dashboard.module").then((m) => m.DashboardModule),
      },
      {
        path: "account",
        canActivate: [RoleGuard],
        data: { role: "rd_account" },
        loadChildren: () =>
          import("./module/account/account.module").then(
            (m) => m.AccountModule
          ),
      },
      {
        path: "collis",
        loadChildren: () =>
          import("./module/collis/collis.module").then((m) => m.CollisModule),
      },
      {
        path: "agence",
        canActivate: [RoleGuard],
        data: { role: "rd_agence" },
        loadChildren: () =>
          import("./module/agence/agence.module").then((m) => m.AgenceModule),
      },
      {
        path: "role",
        canActivate: [RoleGuard],
        data: { role: "rd_role" },
        loadChildren: () =>
          import("./module/role/role.module").then((m) => m.RoleModule),
      },
      {
        path: "setting",
        canActivate: [RoleGuard],
        data: { role: "rd_setting" },
        loadChildren: () =>
          import("./module/setting/setting.module").then(
            (m) => m.SettingModule
          ),
      },
      {
        path: "bordeaureau",
        canActivate: [RoleGuard],
        data: { role: "cr_bordereau" },
        loadChildren: () =>
          import("./module/bordeaureau/bordeaureau.module").then(
            (m) => m.BordeaureauModule
          ),
      },
      {
        path: "bus",
        canActivate: [RoleGuard],
        data: { role: "rd_bus" },
        loadChildren: () =>
          import("./module/bus/bus.module").then((m) => m.BusModule),
      },
      {
        path: "dispatching",
        canActivate: [RoleGuard],
        data: { role: "rd_dispatching" },
        loadChildren: () =>
          import("./module/dispatching/dispatching.module").then(
            (m) => m.DispatchingModule
          ),
      },
      {
        path: "listbordeaureau",
        canActivate: [RoleGuard],
        data: { role: "rd_bordereau" },
        loadChildren: () =>
          import("./module/listbordereau/listbordereau.module").then(
            (m) => m.ListbordereauModule
          ),
      },
      {
        path: "session",
        loadChildren: () =>
          import("./module/raportsession/raportsession.module").then(
            (m) => m.RaportsessionModule
          ),
      },
      {
        path: "logs",
        canActivate: [RoleGuard],
        data: { role: "rd_colislogs" },
        loadChildren: () =>
          import("./module/colislogs/colislogs.module").then(
            (m) => m.ColislogsModule
          ),
      },
      {
        path: "client",
        loadChildren: () =>
          import("./module/clientcompte/clientcompte.module").then(
            (m) => m.ClientcompteModule
          ),
      },
      {
        path: "chauffeur",
        canActivate: [RoleGuard],
        data: { role: "rd_chauffeur" },
        loadChildren: () =>
          import("./module/chauffeur/chauffeur.module").then(
            (m) => m.ChauffeurModule
          ),
      },
      {
        path: "bagage",
        canActivate: [RoleGuard],
        data: { role: "rd_bagage" },
        loadChildren: () =>
          import("./module/bagages/bagages.module").then(
            (m) => m.BagagesModule
          ),
      },
      {
        path: "voyage",
        loadChildren: () =>
          import("./module/voyage/voyage.module").then((m) => m.VoyageModule),
      },
      {
        path: "category",
        canActivate: [RoleGuard],
        data: { role: "rd_category" },
        loadChildren: () =>
          import("./module/category/category.module").then(
            (m) => m.CategoryModule
          ),
      },
      {
        path: "tarif",
        canActivate: [RoleGuard],
        data: { role: "rd_tarifvoyage" },
        loadChildren: () =>
          import("./module/tarif/tarif.module").then((m) => m.TarifModule),
      },
      {
        path: "reservation",
        canActivate: [RoleGuard],
        data: { role: "rd_reservation" },
        loadChildren: () =>
          import("./module/reservation/reservation.module").then(
            (m) => m.ReservationModule
          ),
      },
      {
        path: "passagerlist",
        loadChildren: () =>
          import("./module/passager/passager.module").then(
            (m) => m.PassagerModule
          ),
      },
      {
        path: "typevoyage",
        canActivate: [RoleGuard],
        data: { role: "rd_typevoyage" },
        loadChildren: () =>
          import("./module/typevoyage/typevoyage.module").then(
            (m) => m.TypevoyageModule
          ),
      },
      {
        path: "free",
        loadChildren: () =>
          import("./module/freeticket/freeticket.module").then(
            (m) => m.FreeticketModule
          ),
      },
      {
        path: "passengertravel",
        loadChildren: () =>
          import(
            "./module/freepassenger-ticket/freepassenger-ticket.module"
          ).then((m) => m.FreepassengerTicketModule),
      },
      {
        path: "searchcolis",
        loadChildren: () =>
          import("./module/searchdata/searchdata.module").then(
            (m) => m.SearchdataModule
          ),
      },
      {
        path: "fiscalite",
        loadChildren: () =>
          import("./module/fiscalite/fiscalite.module").then(
            (m) => m.FiscaliteModule
          ),
      },
      {
        path: "raport",
        loadChildren: () =>
          import("./module/raport/raport.module").then((m) => m.RaportModule),
      },
      {
        path: "chef-report",
        loadChildren: () =>
          import("./module/chef-guichet-report/chef-guichet-report.module").then(
            (m) => m.ChefGuichetReportModule
          ),
      },
      {
        path: "sync",
        loadChildren: () =>
          import("./synchronization/synchronization.module").then(
            (m) => m.SynchronizationModule
          ),
      },
      {
        path: "chef-courrier",
        loadChildren: () =>
          import("./module/chef-courrier/chef-courrier.module").then(
            (m) => m.ChefCourrierModule
          ),
      },
      {
        path: "daily-activity-report",
        loadChildren: () =>
          import("./module/daily-activity-report/daily-activity-report.module").then(
            (m) => m.DailyActivityReportModule
          ),
      },
    ],
  },
  {
    path: "login",
    loadChildren: () =>
      import("./module/login/login.module").then((m) => m.LoginModule),
  },
  {
    path: "tracking",
    loadChildren: () =>
      import("./module/mailtracking/mailtracking.module").then(
        (m) => m.MailtrackingModule
      ),
  },
  {
    path: "door",
    canActivate: [AuthGuard],
    loadChildren: () => import("./door/door.module").then((m) => m.DoorModule),
  },
];
